import { cn } from "@gigpro/ui/tailwind/cn";
import type { HireFee } from "@sidegigllc/api/client";
import { jobsPlanHireFeeMessage } from "domains/hire/hireFeePlan";
import { useJobsSubscription } from "domains/hire/hooks/useJobsSubscription";
import { formatCents } from "domains/hire/utils/hireFee";

interface HireFeeWidgetDetailedProps {
  hireFee: HireFee;
  proFirstName?: string;
  className?: string;
}

export const HireFeeWidgetDetailed = ({ hireFee, proFirstName, className }: HireFeeWidgetDetailedProps) => {
  const jobsPlanMessage = jobsPlanHireFeeMessage(hireFee.pricing, proFirstName, useJobsSubscription());
  if (jobsPlanMessage) {
    return (
      <div
        className={cn("rounded-xl border border-light-gray bg-background p-4 text-base/relaxed text-black", className)}
      >
        {jobsPlanMessage}
      </div>
    );
  }

  const hasHours = hireFee.hours_worked_together > 0;
  const hours = Math.round(hireFee.hours_worked_together);

  return (
    <div className={cn("rounded-xl border border-light-gray bg-background p-4", className)}>
      <div className="text-small font-extrabold tracking-wider text-black uppercase">Hire Fee</div>

      <div className="mb-0.5 flex items-baseline gap-1.5">
        <span className="text-screenTitle font-black text-brand">
          {hireFee.is_free ? "FREE" : formatCents(hireFee.fee_cents)}
        </span>
        {hireFee.discount_cents > 0 && (
          <s className="text-large text-medium-gray">{formatCents(hireFee.base_fee_cents)}</s>
        )}
      </div>

      <div className="text-base/relaxed text-medium-gray">
        {hasHours ? (
          <p>
            <span className="font-extrabold text-black">{hours} hrs</span> worked together
          </p>
        ) : (
          <p>
            No shifts together yet. Book shifts to reduce the hire fee by{" "}
            <span className="font-extrabold text-black">{formatCents(hireFee.discount_per_hour_cents)}/hr</span> worked.
          </p>
        )}
      </div>
    </div>
  );
};
HireFeeWidgetDetailed.displayName = "HireFeeWidgetDetailed";
